<template>
    <div class="404-container" style="text-align: center;margin-top: 300px;">
        <h1>404 NotFound 请您检查路由地址是否正确</h1>
        <br>
        <h2>您也可以联系微信：15921291928</h2>
    </div>
</template>

<script>
  export default {
    name: "NotFound"
  }
</script>

<style scoped lang="less">

</style>